import { render, staticRenderFns } from "./ExternalNode.vue?vue&type=template&id=33dd3316&"
import script from "./ExternalNode.vue?vue&type=script&lang=js&"
export * from "./ExternalNode.vue?vue&type=script&lang=js&"
import style0 from "./ExternalNode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports